// import {combineReducers} from 'redux';
import {composeReducers} from 'common/utils/reducers';
import cubesRoot from './cubesReducer';

export default composeReducers(cubesRoot);
